import { ChipProps } from '@mui/material';
import { FilterKeys, Recurrence, useGetEventsQuery } from '@schooly/api';
import { FC } from 'react';

import { RecurrenceTagSelect } from './RecurrenceTagSelect';

export type EventRecurrenceTagSelectProps = {
  id: string;
  schoolId: string;
  onClear: () => void;
} & Omit<ChipProps, 'label'>;

export const EventRecurrenceTagSelect: FC<EventRecurrenceTagSelectProps> = ({
  id,
  schoolId,
  onClear,
  ...props
}) => {
  const { data } = useGetEventsQuery({
    schoolId,
    query: '',
    filters: { [FilterKeys.RecurrenceId]: [id] },
  });

  const firstEvent = data?.pages?.[0]?.results?.[0];

  const recurrenceId = firstEvent?.recurring_state?.recurrence_id ?? null;
  const recurrenceTitle = firstEvent?.recurring_state?.recurrence_name ?? null;

  const recurrence: Recurrence | null =
    recurrenceId && recurrenceTitle
      ? {
          id: recurrenceId,
          title: recurrenceTitle,
        }
      : null;

  return (
    <RecurrenceTagSelect
      onClear={onClear}
      schoolId={schoolId}
      recurrence={recurrence}
      id={id}
      {...props}
    />
  );
};
